module.exports = __webpack_public_path__ + "img/logo PWr kolor poziom  bez tla.4bbd6631.png";